import { makeAutoObservable } from 'mobx';
import { ISaveable } from '../../../../../stores/types';
import { ICredentialsStore } from '../integration-store';

export interface IPeoplevoxCredentials {
    username: string,
    password: string,
    customer_code: string,
}

class PeoplevoxCredentialsStore implements ISaveable, ICredentialsStore {
    private _changes: IPeoplevoxCredentials = {} as IPeoplevoxCredentials;

    constructor() {
        makeAutoObservable(this);
    }

    public get username() { return this._changes.username; }
    public get password() { return this._changes.password; }
    public get customer_code() { return this._changes.customer_code; }

    public set username(v: string) { this._changes.username = v; }
    public set password(v: string) { this._changes.password = v; }
    public set customer_code(v: string) { this._changes.customer_code = v; }

    /** ICredentialsStore implementation ************/
    public async getCredentials() {
        return { ...this._changes };
    }


    /********* ISaveable implementation *************/
    public hasChanges(): boolean {
        return !!Object.keys(this._changes).length;
    }

    public discardChanges(): void {
        this._changes = {} as IPeoplevoxCredentials;
    }

    public getUpdatedModel(): IPeoplevoxCredentials { throw new Error('Not implemented.'); }
    public isSaving(): boolean { throw new Error('Not implemented.'); }
    public commitChanges() { throw new Error('Not implemented.'); }
    public async save() { throw new Error('Not implemented.'); }
}

export default PeoplevoxCredentialsStore;
